module.exports = __webpack_public_path__ + "img/alfamart.24dc99c2.svg";